var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "component-upload-image" },
    [
      _c(
        "el-upload",
        {
          class: { hide: this.fileList.length >= this.limit },
          attrs: {
            multiple: "",
            action: _vm.uploadImgUrl,
            "list-type": "picture-card",
            "on-success": _vm.handleUploadSuccess,
            "before-upload": _vm.handleBeforeUpload,
            limit: _vm.limit,
            "on-error": _vm.handleUploadError,
            "on-exceed": _vm.handleExceed,
            name: "file",
            "on-remove": _vm.handleRemove,
            "show-file-list": true,
            headers: _vm.headers,
            "file-list": _vm.fileList,
            "on-preview": _vm.handlePictureCardPreview,
            accept: _vm.accept,
            "http-request": _vm.httpRequest,
            disabled: _vm.disabled,
          },
        },
        [_c("i", { staticClass: "el-icon-plus" })]
      ),
      _vm.showTip
        ? _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [
              _vm._v("\n    请上传\n    "),
              _vm.fileSize
                ? [
                    _vm._v("\n      大小不超过 "),
                    _c("b", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.fileSize) + "MB"),
                    ]),
                  ]
                : _vm._e(),
              _vm.WHtip
                ? [
                    _vm._v("\n      宽度 "),
                    _c("b", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.width) + " px"),
                    ]),
                    _vm._v(" , 高度\n      "),
                    _c("b", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.height) + " px"),
                    ]),
                  ]
                : _vm._e(),
              _vm.fileType
                ? [
                    _vm._v("\n      格式为 "),
                    _c("b", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.fileType.join("/"))),
                    ]),
                  ]
                : _vm._e(),
              _vm._v("\n    的文件\n  "),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "reviewImage" },
        [
          _vm.dialogImageUrl
            ? _c("el-image", {
                ref: "reviewImage",
                staticStyle: { width: "60px", height: "60px" },
                attrs: {
                  src: _vm.dialogImageUrl,
                  fit: "contain",
                  "preview-src-list": [_vm.dialogImageUrl],
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }